<template>
  <div class="panel">
    <div class="panel-head">
      <div class="panel-title">{{ $t('chi115') }}</div>
      <span class="unit">{{ $t('chi116') }}</span>
    </div>
    <div class="panel-body">
      <template v-if="total > 0">
        <div class="donut-wrap">
          <div class="donut" :style="{ background: donutStyle }">
            <div class="donut-text">
              <b>{{ fmt(total, 0) }}</b>
              <span>{{ $t('chi114') }}</span>
            </div>
          </div>
          <div class="legend">
            <div v-for="s in segments" :key="s.name">
              <span><i class="dot" :style="{ background: s.color }"></i>{{ s.name }}</span>
              <b>{{ fmt(s.number, 0) }} · {{ Math.round(s.number / total * 100) }}%</b>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="empty">{{ $t('chi9') }}</div>
    </div>
  </div>
</template>

<script>
import { fmt } from "./statUtils.js";

const COLORS = ["#28b7ee", "#36c78c", "#ffb44c", "#3aa8ff", "#ff6b6b", "#c3d2dc"];

export default {
  name: "PlayDonut",
  props: {
    // getPlayHistoryStatistics / getHistoryMediaStatistics 返回 [{name, number}]
    list: { type: Array, default: () => [] },
  },
  computed: {
    sorted() {
      return [...this.list].sort((a, b) => b.number - a.number);
    },
    total() {
      return this.sorted.reduce((s, p) => s + Number(p.number || 0), 0);
    },
    // 前5 + 其他
    segments() {
      const top5 = this.sorted.slice(0, 5).map((p, i) => ({ ...p, color: COLORS[i] }));
      const rest = this.sorted.slice(5);
      if (rest.length > 0) {
        const restNumber = rest.reduce((s, p) => s + Number(p.number || 0), 0);
        top5.push({
          name: `${this.$t("chi116")} (${rest.length})`,
          number: restNumber,
          color: COLORS[5],
        });
      }
      return top5;
    },
    donutStyle() {
      let acc = 0;
      const grads = this.segments.map((s) => {
        const from = (acc / this.total) * 360;
        acc += Number(s.number);
        const to = (acc / this.total) * 360;
        return `${s.color} ${from.toFixed(1)}deg ${to.toFixed(1)}deg`;
      });
      return `conic-gradient(${grads.join(", ")})`;
    },
  },
  methods: {
    fmt,
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.unit {
  color: #8ca0af;
  font-size: 12px;
}
.panel-body {
  padding: 18px;
}
.donut-wrap {
  display: flex;
  align-items: center;
  gap: 28px;
  min-height: 250px;
  justify-content: center;
  flex-wrap: wrap;
}
.donut {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  position: relative;

  &::after {
    content: "";
    width: 112px;
    height: 112px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
  }
}
.donut-text {
  position: relative;
  z-index: 1;
  text-align: center;

  b {
    font-size: 24px;
    color: #243a4b;
  }

  span {
    display: block;
    color: #7f93a6;
    font-size: 12px;
  }
}
.legend {
  display: grid;
  gap: 10px;

  > div {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    font-size: 14px;
    align-items: center;
    color: #314356;
  }
}
.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.empty {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>
